import { guardNumber } from "../numbers";
import type { Nullable } from "../types";

/**
 * This function returns a unified string version of a number with leading zeros.
 * @example 5 => 005
 */
export function getWarehouseLocationNumberSegmentString(number: Nullable<number>) {
	return guardNumber(number).toString().padStart(3, "0");
}
